import React from 'react';
import * as Styles from './YoutubeEmbed.styles';
import ReactPlayer from 'react-player/youtube';

const YoutubeEmbed = ({
  src = 'https://www.youtube.com/watch?v=2vDI0I6Yfzs',
  width = '560px',
  height = '315px',
  title = 'Youtube embed',
  alt = 'Youtube embed',
  analyticsEventClick = () => {},
}) => {
  const embed = src.replace('watch?v=', 'embed/');

  const handlerClick = () => {
    analyticsEventClick();
  };

  return (
    <Styles.VideoWrapper data-testid="youtube-embed">
      <ReactPlayer
        url={embed}
        controls
        title={title}
        alt={alt}
        height={height}
        width={width}
        onStart={handlerClick}
        config={{
          youtube: {
            playerVars: {
              showinfo: 1,
            },
          },
        }}
      />
    </Styles.VideoWrapper>
  );
};


export default YoutubeEmbed;
